import { Component, OnInit } from '@angular/core';
import { IntranetsService } from '../../../services/intranets/intranets.service';
import { NotyService } from '../../../services/common/noty.service';
@Component({
  selector: 'app-intranet-index',
  templateUrl: './intranet-index.component.html',
  styleUrls: ['./intranet-index.component.scss'],
})
export class IntranetIndexComponent implements OnInit {
  constructor(private intranetsService: IntranetsService, private notyService: NotyService) {}

  intranets: Array<any> = [];

  ngOnInit() {
    this.loadIntranets();
  }

  goToRailsPage(event: Event, url: string) {
    event.preventDefault();
    const token = window.localStorage.getItem('token');
    const separator = url.includes('?') ? '&' : '?';
    window.location.href = token ? `${url}${separator}token=${encodeURIComponent(token)}` : url;
  }

  loadIntranets = () => {
    this.intranetsService
      .index()
      .then((intranetIndex) => {
        console.log('intranetIndex', intranetIndex);
        this.intranets = intranetIndex.intranets;
      })
      .catch();
  };
}
